// BottomNav — Mobil cihazlarda alt sabit navigation bar.
// Sadece 768px altında görünür (CSS media query ile).
// 5 buton: Ana Sayfa / Müşteri / + Yeni / Bildirim / Profil
import React, { useState, useEffect } from 'react';

export default function BottomNav({
  activePage,
  onNavigate,
  unreadCount = 0,
  onOpenSidebar,
  onOpenMenu,
  onOpenNotifications,
  onOpenCommandPalette,
}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const check = () => setVisible(window.innerWidth <= 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  if (!visible) return null;

  const items = [
    {
      key: 'dashboard',
      label: 'Ana Sayfa',
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
      ),
      onClick: () => onNavigate && onNavigate('dashboard'),
    },
    {
      key: 'accounts',
      label: 'Cariler',
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
        </svg>
      ),
      onClick: () => onNavigate && onNavigate('accounts'),
    },
    {
      key: 'search',
      label: 'Ara',
      isPrimary: true,
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/>
        </svg>
      ),
      onClick: () => onOpenCommandPalette && onOpenCommandPalette(),
    },
    {
      key: 'notifications',
      label: 'Bildirim',
      badge: unreadCount,
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/>
        </svg>
      ),
      onClick: () => onOpenNotifications && onOpenNotifications(),
    },
    {
      key: 'menu',
      label: 'Menü',
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
        </svg>
      ),
      onClick: () => onOpenSidebar && onOpenSidebar(),
    },
  ];

  return (
    <nav style={S.nav} aria-label="Alt navigasyon">
      {items.map(it => {
        const isActive = activePage === it.key;
        return (
          <button
            key={it.key}
            type="button"
            onClick={it.onClick}
            style={{
              ...S.btn,
              ...(it.isPrimary ? S.btnPrimary : null),
              ...(isActive && !it.isPrimary ? S.btnActive : null),
            }}
          >
            <span style={S.iconWrap}>
              {it.icon}
              {!!it.badge && it.badge > 0 && (
                <span style={S.badge}>{it.badge > 99 ? '99+' : it.badge}</span>
              )}
            </span>
            <span style={{ ...S.lbl, ...(it.isPrimary ? S.lblPrimary : null) }}>{it.label}</span>
          </button>
        );
      })}
    </nav>
  );
}

const S = {
  nav: {
    position: 'fixed',
    bottom: 0, left: 0, right: 0,
    height: 60,
    paddingBottom: 'env(safe-area-inset-bottom)',
    background: 'var(--bg-secondary)',
    borderTop: '1px solid var(--border-secondary)',
    boxShadow: '0 -2px 12px rgba(0,0,0,0.08)',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'stretch',
    zIndex: 100,
  },
  btn: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    color: 'var(--text-tertiary)',
    padding: '6px 0',
    minHeight: 48,
    fontFamily: 'inherit',
    transition: 'color 0.1s',
  },
  btnActive: { color: 'var(--accent-primary)' },
  btnPrimary: {
    flex: '0 0 60px',
    color: 'var(--text-on-accent)',
  },
  iconWrap: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 44, height: 44,
    borderRadius: '50%',
  },
  badge: {
    position: 'absolute',
    top: 2, right: 2,
    background: 'var(--danger)',
    color: '#fff',
    fontSize: 9,
    fontWeight: 700,
    minWidth: 16, height: 16,
    borderRadius: 8,
    padding: '0 4px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 1,
  },
  lbl: {
    fontSize: 10,
    fontWeight: 500,
  },
  lblPrimary: { color: 'var(--text-on-accent)' },
};

// Primary buton için yuvarlak FAB-style — JS ile özel render
if (typeof document !== 'undefined' && !document.getElementById('bottomnav-style')) {
  const s = document.createElement('style');
  s.id = 'bottomnav-style';
  s.textContent = `
    @media (max-width: 768px) {
      .mdi-content { padding-bottom: 70px !important; }
    }
  `;
  document.head.appendChild(s);
}
